export default __webpack_public_path__ + "images/cta-overlay.svg";